<template>
  <base-widget
    ref="widget"
    :title="$t('sales.title')"
    condensed
    :loading="loading"
    :style="heightStyles"
    :scrollable="items && items.length !== 0"
  >
    <template v-slot:loading>
      <base-skeleton
        v-for="n in 3"
        :key="n"
        :opacity="0 + (1 /n)"
      >
        <div class="d-flex justify-content-between mb-2">
          <div class="w-100">
            <div
              class="skeleton__item"
              style="max-width: 200px"
            />
            <div
              class="skeleton__item"
              style="max-width: 120px"
            />
          </div>
          <div
            class="skeleton__item mt-0 ml-2"
            style="max-width: 40px"
          />
        </div>
        <div class="d-flex">
          <div
            v-for="s in 4"
            :key="s"
            class="skeleton__item mr-2 mt-2"
            style="width: 50px; height: 50px"
          />
        </div>
      </base-skeleton>
    </template>

    <base-list
      v-show="!loading"
      :items="items"
      scrollable-parent-element=".base-widget__content"
      :load-more-bottom-threshold="200"
      mode="loadMore"
      @reached-bottom="$emit('reached-bottom')"
    >
      <template v-slot:nodata>
        <empty
          align="top"
          title="No sales yet"
          subtitle="Here you will see your sales"
        />
      </template>
      <template v-slot:default="{item, index}">
        <SalesCell
          :key="index"
          :customer-name="`${item.customer.first_name} ${item.customer.last_name}`"
          :identifier="item.customer.pk"
          :email="item.customer.email"
          :items="item.sales"
          :attributed="item.attributed !== null ? item.attributed : item.sale_owner"
          :amount="item.formatted_total"
          :order="item.external_id"
          :returned="item.state === 'RETURNED'"
          :return-requested="item.state === 'RETURN_REQUESTED'"
          :sale-transaction="item"
          @client-clicked="$emit('client-clicked', $event)"
        />
      </template>
    </base-list>
  </base-widget>
</template>

<script>
import SalesCell from './Sales/SalesCell';
import minHeightMixin from '../mixins/minheight';

export default {
  name: 'SalesWidget',
  components: {
    SalesCell,
  },
  mixins: [minHeightMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .card-body {
  padding-inline: 0.625rem !important;
  // padding-top: 0 !important; // This was breaking the empty state.
  @media screen and (min-width: map-get($breakpoints,'lg')){
    padding-inline: 0.9375rem !important;
  }
}
::v-deep .base-widget__content {
  padding-right: 5px !important;
  margin-right: -5px !important;
  @media screen and (min-width: map-get($breakpoints,'lg')){
    padding-right: 5px !important;
    margin-right: -10px !important;
  }
}
</style>
